import {
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    Output,
    ViewChild,
} from "@angular/core";
import sysend from "sysend";
import { NavService } from "../../services/nav.service";
import { Client, ClientService } from "../../services/shared/client.service";
import { UserService } from "../../services/user.service";
import { ButtonOption } from "../datatable/datatablecolumn/datatablecolumn.component";

@Component({
    standalone: false,
    selector: "client-switcher",
    templateUrl: "./client-switcher.component.html",
    styleUrls: ["./client-switcher.component.css"],
})
export class ClientSwitcherComponent {
    @ViewChild("openModal") private modalButton: ElementRef;
    @ViewChild("closeModal") private modalCloseButton: ElementRef;

    @Input("backdrop") backdrop: string | boolean = true;

    @Output("onSelect") onSelect: EventEmitter<any> = new EventEmitter<any>();

    clients: Client[] = [];
    options: ButtonOption[] = [];

    constructor(
        private userService: UserService,
        private clientService: ClientService,
        private changeDetectorRef: ChangeDetectorRef,
        private navService: NavService
    ) {
        this.options = [
            {
                value: "Select",
                click: (controller: any, id: number, item: Client) => {
                    this.userService.setClient(item.name).subscribe((data) => {
                        this.modalCloseButton.nativeElement.click();

                        this.resetDetail(data, item);

                        sysend.broadcast("client-switcher", {
                            user: data,
                            client: item,
                        });

                        if (this.onSelect) this.onSelect.emit();

                        if (!this.changeDetectorRef["destroyed"])
                            this.changeDetectorRef.detectChanges();
                    });
                },
            },
        ];
    }

    ngOnInit() {
        sysend.on("client-switcher", (data: any) => {
            this.resetDetail(data.user, data.client);
            if (this.onSelect) this.onSelect.emit();
        });
    }

    async show() {
        let data = await this.clientService.getAll().toPromise();
        this.modalButton.nativeElement.click();

        setTimeout(() => {
            this.clients = data;
        }, 300);
    }

    resetDetail(user, client) {
        this.userService.setUser(user);
        this.navService.setClient(client);
    }
}
